export const currency = (input: number) => {
    return input.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
}